import { url } from "./config";

export var logo: string = '';
export var logoDasboard: string = '';

try {
  console.log();

  let datos = JSON.parse(localStorage.getItem('calidad_user_tag_1'));
  let nombre: string = datos.name;
  if (nombre.localeCompare('Locatec') == 0) {

    logo = url + "upload/locatec-mini.png";
    logoDasboard = url + "upload/locatec.png";
  } else {
    logo = url + "upload/logo.png";
    logoDasboard = url + "upload/logo2.png";
  }
} catch (error) {
  logo = url + "upload/logo.png";
  logoDasboard = url + "upload/logo2.png";
}
//export var logo: string=url+"upload/logo.png";
export var logoLogin: string = url + "upload/logo.png";
export var check: string = url + "upload/mark.png";
export var cancel: string = url + "upload/cancel.png";
export var logoLocatec: string = url + "upload/locatec.png";